import { useTranslation } from "react-i18next";

import type { TFunctionResult } from "i18next";

export type InterpolationType = {
  [key: string]: string | number | TFunctionResult;
};

const GENERIC_ERROR = "GENERIC_ERROR";

export function useErrorCodeTranslation() {
  const { t } = useTranslation("errors");

  return {
    et: (codeCode: string, interpolation?: InterpolationType) => {
      return t(codeCode || GENERIC_ERROR, interpolation);
    },
  };
}
